/*
 * md-personalizacao.js
 * ------------------------------------------------------------
 * Comportamento do painel "Add Name & Number" do Matchday.
 *
 *  - Sanitiza o input de nome (uppercase, so letras/digitos/espaco, trim, 12 chars)
 *  - Sanitiza o input de numero (so digitos, 3 chars)
 *  - Atualiza o preview em tempo real quebrando cada caractere em
 *    <span class="md-ps__letra"> com animation-delay inline, pra
 *    o fade+blur sequencial (stagger 60ms) do CSS
 *  - Troca a fonte do preview via data-font no root quando o usuario
 *    clica numa aba (League / Club / Cup / Standard)
 *  - Os inputs ja saem com name="properties[Name]" e name="properties[Number]",
 *    entao entram automatico no submit do form do produto quando o
 *    atributo form="<id do product-form>" aponta pra ele
 *  - A aba escolhida vai para o pedido em properties[Font]
 * ============================================================ */
(function () {
  "use strict";

  var STAGGER_MS = 60;

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

  function sanitizeNome(v) {
    if (!v) return "";
    var up = String(v).toUpperCase();
    // Aura 02/11: letra com acento fica, o fornecedor estampa (antes JOAO com til perdia a letra)
    if (up.normalize) up = up.normalize("NFC");
    up = up.replace(/[^A-Z0-9 \u00C0-\u00D6\u00D8-\u00DE\u0100-\u024F\u1E00-\u1EFF]/g, "");
    up = up.replace(/\s+/g, " ");
    if (up.charAt(0) === " ") up = up.slice(1);
    if (up.length > 12) up = up.slice(0, 12);
    return up;
  }

  function sanitizeNumero(v) {
    if (!v) return "";
    var only = String(v).replace(/[^0-9]/g, "");
    if (only.length > 3) only = only.slice(0, 3);
    return only;
  }

  function renderLetras(target, texto) {
    if (!target) return;
    target.textContent = "";
    if (!texto) return;
    var chars = texto.split("");
    var frag = document.createDocumentFragment();
    for (var i = 0; i < chars.length; i++) {
      var span = document.createElement("span");
      span.className = "md-ps__letra";
      span.style.animationDelay = (i * STAGGER_MS) + "ms";
      span.textContent = chars[i] === " " ? " " : chars[i];
      frag.appendChild(span);
    }
    target.appendChild(frag);
  }

  function bindPainel(root) {
    if (!root || root.dataset.mdPsBound === "1") return;
    root.dataset.mdPsBound = "1";

    var nameIn = root.querySelector("[data-md-ps-name]");
    var numIn = root.querySelector("[data-md-ps-number]");
    var nameOut = root.querySelector("[data-md-ps-nome-out]");
    var numOut = root.querySelector("[data-md-ps-num-out]");
    var abas = root.querySelectorAll("[data-md-ps-aba]");
    var fontIn = root.querySelector("[data-md-ps-font]");
    // alinha o campo com a aba marcada (no Voltar do Safari o campo voltava com a fonte antiga)
    if (fontIn) {
      var abaAtiva = root.querySelector(".md-ps__aba--ativa");
      fontIn.value = abaAtiva ? abaAtiva.textContent.trim() : "League";
    }

    function sincronizaNome() {
      if (!nameIn) return;
      var limpo = sanitizeNome(nameIn.value);
      if (nameIn.value !== limpo) {
        var pos = limpo.length;
        nameIn.value = limpo;
        try { nameIn.setSelectionRange(pos, pos); } catch (e) { /* type nao suporta */ }
      }
      renderLetras(nameOut, limpo);
    }

    function sincronizaNumero() {
      if (!numIn) return;
      var limpo = sanitizeNumero(numIn.value);
      if (numIn.value !== limpo) {
        var pos = limpo.length;
        numIn.value = limpo;
        try { numIn.setSelectionRange(pos, pos); } catch (e) { /* type nao suporta */ }
      }
      renderLetras(numOut, limpo);
    }

    if (nameIn) {
      nameIn.addEventListener("input", function (ev) {
        // Aura 02/11: acento em duas teclas (Mac, celular) so e limpo quando a letra termina de se formar
        if (ev && ev.isComposing) return;
        sincronizaNome();
      });
      nameIn.addEventListener("compositionend", sincronizaNome);
      nameIn.addEventListener("blur", function () {
        nameIn.value = nameIn.value.replace(/\s+$/g, "");
        sincronizaNome();
      });
      sincronizaNome();
    }

    if (numIn) {
      numIn.addEventListener("input", sincronizaNumero);
      numIn.addEventListener("blur", sincronizaNumero);
      sincronizaNumero();
    }

    if (abas && abas.length) {
      for (var i = 0; i < abas.length; i++) {
        (function (aba) {
          aba.addEventListener("click", function (ev) {
            ev.preventDefault();
            var alvo = aba.getAttribute("data-md-ps-aba") || "league";
            for (var j = 0; j < abas.length; j++) {
              var ativa = abas[j] === aba;
              abas[j].classList.toggle("md-ps__aba--ativa", ativa);
              abas[j].setAttribute("aria-selected", ativa ? "true" : "false");
            }
            root.setAttribute("data-font", alvo);
            // a fonte escolhida vai para o pedido junto com o nome e o número
            if (fontIn) fontIn.value = (aba.textContent || alvo).trim();
            if (nameOut && nameOut.firstChild) {
              var txtN = nameIn ? sanitizeNome(nameIn.value) : "";
              renderLetras(nameOut, txtN);
            }
            if (numOut && numOut.firstChild) {
              var txtNum = numIn ? sanitizeNumero(numIn.value) : "";
              renderLetras(numOut, txtNum);
            }
          });
        })(abas[i]);
      }
    }
  }

  function bindTudo(scope) {
    var raiz = scope || document;
    var paineis = raiz.querySelectorAll("[data-md-ps]");
    for (var i = 0; i < paineis.length; i++) {
      bindPainel(paineis[i]);
    }
  }

  ready(function () {
    bindTudo(document);

    document.addEventListener("shopify:section:load", function (e) {
      if (e && e.target) bindTudo(e.target);
    });

    if (typeof window.MutationObserver === "function") {
      var obs = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches("[data-md-ps]")) {
              bindPainel(node);
            } else if (node.querySelectorAll) {
              bindTudo(node);
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
